import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { FaRegFlag, FaFlag } from "react-icons/fa";
import styled from "styled-components";
import { FOLLOWUP_CODES } from "../constants/followup.js";
import { createPortal } from "react-dom";

const NoCaretButton = styled(Dropdown.Toggle)`
   &::after {
      display: none !important;
   }
`;

const FlagDropdown = ({ detailId, flagValue, onSelect }) => {
   const [isOpen, setIsOpen] = useState(false);
   const [selectedFlag, setSelectedFlag] = useState(flagValue);

   const handleSelect = (value) => {
      setSelectedFlag(value);
      onSelect(detailId, value);
      setIsOpen(false);
   };

   return (
      <Dropdown
         show={isOpen}
         onToggle={(isOpen) => setIsOpen(isOpen)}>
         <NoCaretButton
            variant="light"
            id={`dropdownFlag-${detailId}`}
            className="btn"
            onClick={() => setIsOpen(!isOpen)}>
            {selectedFlag === "-1" ? (
               <FaRegFlag
                  size={16}
                  color="grey"
               />
            ) : (
               <FaFlag
                  size={16}
                  color="orange"
               />
            )}
         </NoCaretButton>

         {createPortal(
            <Dropdown.Menu
               container={document.body}
               style={{
                  position: "fixed",
                  zIndex: 1050,
               }}>
               <Dropdown.ItemText className="ps-2">
                  <small>Followup tags</small>
               </Dropdown.ItemText>
               {FOLLOWUP_CODES.map(({ value, label }, index) => (
                  <div key={`followup-${value}`}>
                     {value === "-1" && <Dropdown.Divider key={`divider-${index}`} />}
                     <Dropdown.Item
                        key={`followup-menu-${index}`}
                        onClick={() => handleSelect(value)}
                        active={value === flagValue}>
                        {label}
                     </Dropdown.Item>
                  </div>
               ))}
            </Dropdown.Menu>,
            document.body // Forces rendering inside <body>
         )}
      </Dropdown>
   );
};

export default FlagDropdown;
